module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADZSURBVHgBtVSBDcIgEDyaDsAGsoGOoBPoBnYDXcUJdIQ6gW6gbuAIboD3SmNNoH2a9pILz/Mc8P8BGBmma9F7bznsyTkpdk2ejTFP5IJiC/JG7shZmFfkRWzkImx0Eb8LB9nYviIhVnG4x54WfPL0rVoQ35zVSONBuhxBi268UjEFRkbZGCHJTfWc2PSl2urTRlxfhrnkW27960OpnCxgGBwFV38eaRMMRHvv6DlUCfIGG3KtiS2hgxTMawKna5seXJVxOsGc76otaGO/ixI2JnggjxiGE6bCG/NSYmjM6ZXCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/us2.png
// module id = xOoC
// module chunks = 1